export const ProjectStatusCode = {
  NOT_STARTED: '미시작',
  STARTED: '진행중',
  DONE: '종료',
};

export const ProjectStatusCodeColor = {
  NOT_STARTED: '#ff7a45',
  STARTED: '#084298',
  DONE: '#262626',
};

export const EstimateStatusCode = {
  NOT_REGISTERED: '미신청',
  NOT_STARTED: '미시작',
  STARTED: '진행중',
  DONE: '종료',
};

export const EstimateStatusCodeColor = {
  NOT_REGISTERED: '#ff4d4f',
  NOT_STARTED: '#ffa940',
  STARTED: '#096dd9',
  DONE: '#737373',
};

export const EstimateStatusOrderIndex = {
  NOT_REGISTERED: 0,
  NOT_STARTED: 1,
  STARTED: 2,
  DONE: 3,
};

export const StatusColor = {
  STARTED: '#20c997',
  UPLOADING: '#198754',
  REVIEWING: '#ffc107',
  FEEDBACK: '#084298',
  DONE: '#2b2f32',
};

export const CycleStatus = {
  STARTED: '시작',
  UPLOADING: '업로드중',
  REVIEWING: '검토중',
  FEEDBACK: '피드백 완료',
  DONE: '최종 완료',
};

export const CycleStatusOrderIndex = {
  STARTED: 0,
  UPLOADING: 1,
  REVIEWING: 2,
  FEEDBACK: 3,
  DONE: 4,
};

export const CycleStatusUpdateMessage = {
  STARTED: '회차 상태를 "시작(STARTED)" 상태로 변경 완료하였습니다.',
  UPLOADING: '회차 상태를 "업로드중(UPLOADING)" 상태로 변경 완료하였습니다.',
  REVIEWING: '회차 상태를 "검토중(REVIEWING)" 상태로 변경 완료하였습니다.',
  FEEDBACK:
    '회차 상태 - "피드백 완료(FEEDBACK)" 변경, 피드백 알림 메일 전송 및 사업장 산정 회차 추가를 완료하였습니다.',
  DONE: '회차 상태 - "종료(DONE)" 변경, 사업장 산정 최종결과 및 완료 메일 전송을 완료하였습니다.',
};

export const ProjectAttachmentsRequired = [
  {
    key: 'TEMPLATE',
    label_ko: '산정 템플릿',
    label_en: 'Calculation Template',
    label_zh: '核算模板',
  },
];

export const ProjectAttachments = [
  {
    key: 'SCOPE12',
    label_ko: 'SCOPE12',
    label_en: 'SCOPE12',
    label_zh: 'SCOPE12',
  },
  {
    key: 'WASTE',
    label_ko: '폐기물',
    label_en: 'Waste',
    label_zh: '废弃物',
  },
  {
    key: 'MATERIAL',
    label_ko: '원부자재',
    label_en: 'Materials',
    label_zh: '原材料',
  },
  {
    key: 'TRANSPORT',
    label_ko: '공급업체 운송',
    label_en: 'Supplier',
    label_zh: '供应商',
  },
];

export let EstimateCylcle = {
  1: [
    // {
    //   cycle_index: 5,
    //   cycle_round: 2,
    //   cycle_status: 'STARTED',
    //   SCOPE12: [],
    //   WASTE: [],
    //   MATERIAL: [],
    //   TRANSPORT: [],
    //   feedback: null,
    // },
    // {
    //   cycle_index: 4,
    //   cycle_round: 1,
    //   cycle_status: 'DONE',
    //   TEMPLATE: [
    //     {
    //       id: 425230,
    //       filename: t('템플릿 증빙서류'),
    //       attch_type: 'TEMPLATE',
    //       feedback: '필수 데이터가 누락되었습니다.',
    //       approved: false,
    //     },
    //   ],
    //   SCOPE12: [
    //     {
    //       id: 425231,
    //       filename: 'SCOPE 1 산정 증빙서류',
    //       attch_type: 'SCOPE12',
    //       feedback: '필수 데이터가 누락되었습니다.',
    //       approved: false,
    //     },
    //     {
    //       id: 425241,
    //       filename: 'SCOPE 2 산정 증빙서류',
    //       attch_type: 'SCOPE12',
    //       feedback: null,
    //       approved: true,
    //     },
    //   ],
    //   WASTE: [
    //     {
    //       id: 425232,
    //       filename: 'WASTE 산정 증빙서류',
    //       attch_type: 'WASTE',
    //       feedback: '일부 데이터가 누락되었습니다.',
    //       approved: false,
    //     },
    //   ],
    //   MATERIAL: [
    //     {
    //       id: 425233,
    //       filename: 'MATERIAL 산정 증빙서류',
    //       attch_type: 'MATERIAL',
    //       feedback: '증빙서류로 적절하지 않은 부분이 있습니다.',
    //       approved: false,
    //     },
    //   ],
    //   TRANSPORT: [
    //     {
    //       id: 425234,
    //       filename: 'TRANSPORT 산정 증빙서류',
    //       attch_type: 'TRANSPORT',
    //       feedback: '증빙서류로 적절하지 않은 부분이 있습니다.',
    //       approved: false,
    //     },
    //   ],
    //   feedback: '다음 회차에서 산정 평가를 계속하겠습니다.',
    // },
    // {
    //   cycle_index: 3,
    //   cycle_round: 1,
    //   cycle_status: 'FEEDBACK',
    //   TEMPLATE: [
    //     {
    //       id: 325230,
    //       filename: t('템플릿 증빙서류'),
    //       attch_type: 'TEMPLATE',
    //       feedback: '필수 데이터가 누락되었습니다.',
    //     },
    //   ],
    //   SCOPE12: [
    //     {
    //       id: 325231,
    //       filename: 'SCOPE 1 산정 증빙서류',
    //       attch_type: 'SCOPE12',
    //       feedback: '필수 데이터가 누락되었습니다.',
    //     },
    //     {
    //       id: 325241,
    //       filename: 'SCOPE 2 산정 증빙서류',
    //       attch_type: 'SCOPE12',
    //       feedback: null,
    //     },
    //   ],
    //   WASTE: [
    //     {
    //       id: 325232,
    //       filename: 'WASTE 산정 증빙서류',
    //       attch_type: 'WASTE',
    //       feedback: null,
    //     },
    //   ],
    //   MATERIAL: [
    //     {
    //       id: 325233,
    //       filename: 'MATERIAL 산정 증빙서류',
    //       attch_type: 'MATERIAL',
    //       feedback: null,
    //     },
    //   ],
    //   TRANSPORT: [
    //     {
    //       id: 325234,
    //       filename: 'TRANSPORT 산정 증빙서류',
    //       attch_type: 'TRANSPORT',
    //       feedback: null,
    //     },
    //   ],
    //   feedback: '다음 회차에서 산정 평가를 계속하겠습니다.',
    // },
    // {
    //   cycle_index: 2,
    //   cycle_round: 1,
    //   cycle_status: 'UPLOADING',
    //   TEMPLATE: [
    //     {
    //       id: 225230,
    //       filename: t('템플릿 증빙서류'),
    //       attch_type: 'SCOPE12',
    //       approved: null,
    //       feedback: null,
    //     },
    //   ],
    //   SCOPE12: [
    //     {
    //       id: 225231,
    //       filename: 'SCOPE 1 관련 증빙서류',
    //       attch_type: 'SCOPE12',
    //       approved: null,
    //       feedback: null,
    //     },
    //     {
    //       id: 225241,
    //       filename: 'SCOPE 2 관련 증빙서류',
    //       attch_type: 'SCOPE12',
    //       approved: null,
    //       feedback: null,
    //     },
    //   ],
    //   WASTE: [
    //     {
    //       id: 225232,
    //       filename: 'WASTE 관련 증빙서류',
    //       attch_type: 'WASTE',
    //       approved: null,
    //       feedback: null,
    //     },
    //   ],
    //   MATERIAL: [
    //     {
    //       id: 225233,
    //       filename: 'MATERIAL 관련 증빙서류',
    //       attch_type: 'MATERIAL',
    //       approved: null,
    //       feedback: null,
    //     },
    //   ],
    //   TRANSPORT: [
    //     {
    //       id: 225234,
    //       filename: 'TRANSPORT 관련 증빙서류',
    //       attch_type: 'TRANSPORT',
    //       approved: null,
    //       feedback: null,
    //     },
    //   ],
    //   feedback: null,
    // },
    {
      cycle_index: 1,
      cycle_round: 1,
      cycle_status: 'STARTED',
      SCOPE12: [],
      WASTE: [],
      MATERIAL: [],
      TRANSPORT: [],
      feedback: null,
    },
  ],
};
